import React from 'react';

import { EvaluationsFeedback } from '../feedback/EvaluationsFeedback';
import { EvaluationsStartup } from '../startup/EvaluationsStartup';
import * as Styled from './StyledEvaluations';

export const Evaluations = ({ evaluations, t }) => (
    <Styled.Evaluations>
        <Styled.EvaluationsThead>
            <Styled.EvaluationsTr>
                <Styled.EvaluationsTh>
                    {t('dashboard.Evaluations.startup')} ({evaluations.length})
                </Styled.EvaluationsTh>
                <Styled.EvaluationsTh>{t('dashboard.Evaluations.feedback')}</Styled.EvaluationsTh>
                <Styled.EvaluationsTh>{t('dashboard.Evaluations.stage')}</Styled.EvaluationsTh>
                <Styled.EvaluationsTh>{t('dashboard.Evaluations.group')}</Styled.EvaluationsTh>
                <Styled.EvaluationsTh>{t('dashboard.Evaluations.comment')}</Styled.EvaluationsTh>
            </Styled.EvaluationsTr>
        </Styled.EvaluationsThead>

        <Styled.EvaluationsTbody>
            {evaluations.map(evaluation => (
                <tr key={evaluation._id}>
                    <td>
                        <EvaluationsStartup
                            date={evaluation.regDate}
                            startup={evaluation.startup}
                        />
                    </td>
                    <td>
                        <EvaluationsFeedback evaluation={evaluation} />
                    </td>
                    <td>{evaluation.stage ?? 'N/A'}</td>
                    <td>{evaluation.group ?? 'N/A'}</td>
                    <td>{evaluation.comment ?? ''}</td>
                </tr>
            ))}
        </Styled.EvaluationsTbody>
    </Styled.Evaluations>
);
